export const SAVE_ALL_AUDITS = 'SAVE_ALL_AUDITS'